import { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, TextField, CircularProgress, Alert } from '@mui/material';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function AddCustomerModal({ open, onClose, onSubmit }) {
    const [clientName, setClientName] = useState('');
    const [clientCode, setClientCode] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        // Clear form when modal opens
        if (open) {
            setClientName('');
            setClientCode('');
            setError('');
        }
    }, [open]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!clientName || !clientCode) {
            setError('Both fields are required.');
            return;
        }

        setIsSubmitting(true);
        setError('');

        try {
            // Pass the new customer data to the parent's submit handler
            await onSubmit({ clientName, clientCode });
        } catch (e) {
            setError(e.message || 'An unexpected error occurred.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle} component="form" onSubmit={handleSubmit}>
                <Typography variant="h6" component="h2">Add New Customer</Typography>
                {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
                <TextField
                    label="Client Name"
                    value={clientName}
                    onChange={(e) => setClientName(e.target.value)}
                    fullWidth
                    required
                    sx={{ mt: 2 }}
                />
                <TextField
                    label="Client Code"
                    value={clientCode}
                    onChange={(e) => setClientCode(e.target.value)}
                    fullWidth
                    required
                    sx={{ mt: 2 }}
                />
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={onClose} disabled={isSubmitting}>Cancel</Button>
                    <Button type="submit" variant="contained" disabled={isSubmitting}>
                        {isSubmitting ? <CircularProgress size={24} /> : 'Submit'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

